/* 
 * Mobile menu component modul
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
var $ = require('jquery');
require('jquery.mmenu/dist/js/jquery.mmenu.min');
require('jquery.mmenu/dist/addons/autoheight/jquery.mmenu.autoheight.min');
require('jquery.mmenu/dist/addons/searchfield/jquery.mmenu.searchfield.min');
require('jquery.mmenu/dist/addons/navbars/jquery.mmenu.navbars.min');
require('jquery.mmenu/dist/addons/setselected/jquery.mmenu.setselected.min');

// Modul construct
var somModul = {
	
	// Module name
	name: 'mmenu',
	
	container: null,
	
	// Init function
	init: function() {
	
		// Init vars
		var scope = this;
		var componentConfig = this.__getComponentConfig(somModul.name);
		somModul.container = $(componentConfig.container.main);
		if(componentConfig.enabled && somModul.container.length == 1) {
			
			// Clone elements
			somModul.cloneElements(scope);
			
			// Handle elements with special position - insert after initialisation
			var $specialPositionElements = somModul.container.find('*[data-position]');
			var $specialPositionElementsClones = $specialPositionElements.clone();
			$specialPositionElements.remove();
			
			// Init menu
			somModul.container.mmenu(componentConfig.mopt, componentConfig.mconf);
			var menuApi = somModul.container.data('mmenu');
			$(componentConfig.container.control).click(function() {
				menuApi.open();
			});
			
			// Add special position elements after initialisation
			var $menuInstance = menuApi.getInstance().$menu;
			$specialPositionElementsClones.each(function() {
				var $element = $(this);
				var position = $element.data('position');
				$element.removeAttr('data-position');
				
				if(position == 'header') {
					$element.prependTo($menuInstance);
				} else if(position == 'footer') {
					$element.appendTo($menuInstance);
				}
			});

			return true;
		}
	},
	
	// Clone elements
	cloneElements: function(project) {
		somModul.container.find('div[data-clone]').each(function() {

			var $elementToClone = $(this);
			var selector = $elementToClone.data('clone');
			var $target = $(selector);
			if($target.length != 0) {
				var $clonedItem = $target.clone().insertAfter($elementToClone);

				// Add user defined class if needed
				var addClass = $elementToClone.data('add-class');
				if(typeof addClass != 'undefined') {
					$clonedItem.removeClass().addClass(addClass);
				}
				
				// Add position data attribute for further processing
				var dataPosition = $elementToClone.data('position');
				if(typeof dataPosition != 'undefined') {
					$clonedItem.attr('data-position', 'header');
				}

				$elementToClone.remove();
			} else if(project.config.project.devMode) {
				console.log('Project component mmenu: Can not clone "' + selector + '" into mmenu container.');
			}
		});
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;


/** WEBPACK FOOTER **
 ** ./src/components/mmenu.js
 **/